import { render, staticRenderFns } from "./ShukkaAnkenKakutei.vue?vue&type=template&id=4b5260e4"
import script from "./ShukkaAnkenKakutei.vue?vue&type=script&lang=js"
export * from "./ShukkaAnkenKakutei.vue?vue&type=script&lang=js"
import style0 from "./ShukkaAnkenKakutei.vue?vue&type=style&index=0&id=4b5260e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports